import { type StudyRunCaseDashboardGateCardDto } from '@@types/api.types';
import { Tile } from '@components/shared/tile.component';
import { Badge } from '@components/ui/badge';
import type { FC } from 'react';
import { getGateStatusLabel, getGateStatusTone } from './meia-p4-run-cases.util';

type MeiaP4GateStatusPanelProps = {
  gates: StudyRunCaseDashboardGateCardDto[];
};

export const MeiaP4GateStatusPanel: FC<MeiaP4GateStatusPanelProps> = (props) => {
  const { gates } = props;
  if (gates.length === 0) return null;

  return (
    <Tile header={{ title: 'Gate Status' }}>
      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
        {gates.map((gate) => (
          <div
            className="flex flex-col gap-1 rounded-md border border-gray-200 p-3"
            key={gate.gate}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-medium text-gray-900">
                <span className="mr-1.5 font-mono text-gray-400">{gate.gate}</span>
                {gate.label}
              </span>
              <Badge
                size="xs"
                variant={getGateStatusTone(gate.status).badgeVariant}
              >
                {getGateStatusLabel(gate.status)}
              </Badge>
            </div>
            <p className="text-[11px] leading-relaxed text-gray-600">{gate.detail}</p>
            {gate.reason && <p className="text-[11px] text-gray-400">{gate.reason}</p>}
          </div>
        ))}
      </div>
    </Tile>
  );
};
